import { Injectable } from '@angular/core';
import PouchDB from 'pouchdb';
import PouchdbFind from 'pouchdb-find';
import { Subject } from 'rxjs/Rx';
import { Constants } from '../shared/models/constants';
import { LoginObservableService } from "./loginObservable.service";
import { debug } from 'util';
import { ExportviewComponent } from '../bookShared/popups/export/export.component';
import * as _ from 'lodash';
import { InboxBids } from './models/inboxBids';
import { InboxBookData } from './models/inboxBookData';
import { Component_interactionService } from '../component_interaction.service';
import { StaticDocs } from './models/staticDocs';

@Injectable()
export class PouchdbService {
    localDB; remoteDB;

    islogined: Subject<any> = new Subject();
    islogined$ = this.islogined.asObservable();


    isReplicated: Subject<any> = new Subject();
    isReplicated$ = this.isReplicated.asObservable();

    syncingData: Subject<any> = new Subject();
    syncingData$ = this.syncingData.asObservable();


    constructor(private LoginObservableService: LoginObservableService, private compentInteractionSerive: Component_interactionService) {

        // var data = JSON.parse(localStorage.nasResponse);
        //this.connnectToPouchDB(data)
    }

    getLogin(data) {
        // this.islogined.next(data);
        // this.islogined = data;


    }

    connnectToPouchDB(data, state) {

        var self = this;
        var temp = JSON.parse(localStorage.nasResponse);
        Constants.USER = `${temp.signIn.organizationId}_${temp.signIn.user.id}`;

        if (localStorage.appServer == 'Live') {
            Constants.syncUrl = '@sync.semanoor.com';
            Constants.lcsUrl = 'liquidgql.semanoor.com';
            Constants.nasUrl = 'admingql.semanoor.com';

        }
        else if (localStorage.appServer == 'Dev') {
            Constants.syncUrl = '@sync-dev.semanooor.com';
            Constants.lcsUrl = 'lcsgql-dev.semanooor.com';
            Constants.nasUrl = 'nasgql-dev.semanooor.com';
        }


        this.localDB = null;
        this.localDB = new PouchDB(Constants.USER);
        //this.remoteDB = new PouchDB('http://webteamu444:nooorv2@192.168.1.57:4984/nooorlite');


        // this.remoteDB = new PouchDB(`http://${Constants.USER}:@sync.semanoor.com/db`)
        this.remoteDB = new PouchDB(`http://${Constants.USER}:${Constants.syncUrl}/db`)
        PouchDB.plugin(PouchdbFind);


        if (state == 'firstuser') {
            this.syncwithpouch(state);
        }

        else {
            this.syncwithpouch('');
        }



        this.localDB.createIndex({
            index: {
                fields: ['type', 'storeType', '_id', 'storeDetails', 'books', 'title', 'book', 'recents', 'bookData', 'storeFavorites', 'storeRecents']
            }
        }).then(function (result) {
            //alert('done');


        }).catch(function (err) {
        });

    }
    formedBooksArr = [];
    uniqBooksArray = [];
    uniquebookid: any
    updateNewChanges(info) {

        var ExportArray = [];

        var self = this;


        this.compentInteractionSerive.loadInboxBids(this.localDB, this.remoteDB, info, '');

    }

    updateAnswerSheetChanges(info) {
        this.compentInteractionSerive.updateAnswerSheet(this.localDB, this.remoteDB, info);
    }

    syncwithpouch(state) {


        var self = this;
        if (state == 'firstuser') {
            self.LoginObservableService.loginChanged('true');
        }


        else {

            self.localDB.allDocs({
                include_docs: true,
                attachments: true
            }).then(function (result) {


                if (result.rows.length > 0) {

                    self.syncwithpouch('firstuser');

                }

                else {
                    self.remoteDB.allDocs({
                        include_docs: true,
                        attachments: true
                    }).then(function (result) {


                        if (result.rows.length > 0) {
                            self.enablesyncwithpouch()
                        }

                        else {
                            self.syncwithpouch('firstuser')
                        }

                    }).catch(function (err) {
                        console.log(err);

                    });
                }

            }).catch(function (err) {
                console.log(err);

            });

        }
    }

    enablesyncwithpouch() {

        var replicateDocs = [
            Constants.USER + '.01.Purchases',
            Constants.USER + '.02.Creations',
            Constants.USER + '.03.Imports',
            Constants.USER + '.04.Favourites',
            Constants.USER + '.00.Recents',
            Constants.USER + '.storeRecents',
            Constants.USER + '.storeSearchRecents',
            Constants.USER + '.storeFavorites',
            Constants.USER + '.pageTemplates',
            Constants.USER + '.bookTemplates',
            Constants.USER + '.inboxBids'
        ]
        var self = this;
        ;

        // this.remoteDB.query('shelfdocs').then(function (res) {
        //     // got the query results
        //     
        // }).catch(function (err) {
        //     // some error
        //     
        // });
        // query(this.remoteDB, 'shelfdocs', {
        //     include_docs: true
        // }).then(function (res) {

        //     
        // }).catch(function (err) {
        //     // some error
        //     
        // });


        this.localDB.replicate.from(this.remoteDB, {
            live: false,
            doc_ids: replicateDocs
        }).on('change', function (info) {
            // handle change       

        }).on('paused', function (err) {
            // replication paused (e.g. replication up to date, user went offline)
        }).on('active', function (info) {

            // replicate resumed (e.g. new changes replicating, user went back online)
        }).on('denied', function (err) {

            // a document failed to replicate (e.g. due to permissions)
        }).on('complete', function (info) {

            // if (localStorage.defaultShelf == 'false') {
            self.LoginObservableService.loginChanged('true');

            // }

            // handle complete
        }).on('error', function (err) {

            // handle error
        });


    }

    getDefaultShelfBookDocs(docs) {
        var self = this;
        return new Promise((resolve, reject) => {

            if (docs.length > 0) {

                self.localDB.replicate.from(self.remoteDB, {
                    live: false,
                    doc_ids: docs
                }).on('change', function (info) {
                    // handle change       

                }).on('complete', function (info) {



                    resolve('completed');

                    self.replicateLocalDbWithBooks('');

                })
            }


            else {

                resolve('completed');
                self.replicateLocalDbWithBooks('');
            }

        });

    }
    startDefaultReplication(state) {
        this.replicateLocalDbWithBooks(state);
    }


    replicateLocalDbWithBooks(state) {

        var self = this;
        if (state)
            self.syncingData.next('Data Pulled');

        else self.syncingData.next('Pulling Data From Server...');



        localStorage.isAppReloaded = true;


        self.localDB.replicate.from(self.remoteDB, {
            live: true,

        }).on('change', function (info) {
            // handle change

            // localStorage.allDocsReplicated = "true";

            // if (localStorage.isAppReloaded == "true") {
            //     if (state == '') self.loadShelfsAfterReplication();
            //     localStorage.isAppReloaded = false;

            // }

            // else {


            if (info.direction == undefined) {
                var obj = {

                    'change': {

                        'docs': info.docs
                    }
                };

                var answersheetDocs = _.filter(obj.change.docs, function (doc) {
                    return doc.type == 'answersheet' && doc._deleted != true
                })
                self.updateAnswerSheetChanges(answersheetDocs);

                var exportDocs = _.filter(obj.change.docs, function (doc) {
                    return doc.type == 'export' && doc._deleted != true
                })
                // self.updateNewChanges(exportDocs);
                self.compentInteractionSerive.updateInboxData(self.localDB, self.remoteDB, exportDocs.length)

            }
            else
                if (info.direction == 'pull') {

                    var answersheetDocs = _.filter(info.change.docs, function (doc) {
                        return doc.type == 'answersheet' && doc._deleted != true
                    })
                    self.updateAnswerSheetChanges(answersheetDocs);

                    var exportDocs = _.filter(info.change.docs, function (doc) {
                        return doc.type == 'export' && doc._deleted != true
                    })
                    // self.updateNewChanges(exportDocs);

                    self.compentInteractionSerive.updateInboxData(self.localDB, self.remoteDB, exportDocs.length)

                }

            // if (state == '') self.loadShelfsAfterReplication();
            //   }


        }).on('complete', function (info) {
            localStorage.isAppReloaded = false;


        })
    }




    loadShelfsAfterReplication() {
        var self = this;
        this.localDB.find({
            selector: { type: 'shelf' },
        }).then(function (result) {


            self.isReplicated.next(result.docs);

            localStorage.purchasesList = JSON.stringify(result.docs[0]);
            self.syncingData.next('Data Pulled');
        })

    }

    startReplicationTo() {
        var self = this;
        self.syncingData.next('Pushing Data To Server...');

        self.localDB.replicate.to(self.remoteDB, {
            live: false,

        }).on('change', function (info) {
            // handle change       


        }).on('complete', function (info) {

            self.syncingData.next('Data Pushed');

        })
    }

    replicateExportDoc(id) {
        var docs = [];
        docs.push(id);
        var self = this;
        self.localDB.replicate.to(self.remoteDB, {
            live: false,
            doc_ids: docs
        }).on('change', function (info) {
            // handle change       

        }).on('complete', function (info) {
        })
    }

    ngOnInit() {

    }
    getCookieData(cookie_name) {
        var name = cookie_name + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

    test() {

    }

    destroyPouchDb() {
        this.LoginObservableService.loginChanged('false');
        localStorage.clear();
        var self = this;
        // this.localDB.destroy().then(function () {
        //    
        //   });
        //   this.localDB = undefined;
        //   this.remoteDB  = undefined;

    }

    addDefaultPouchDB() {

        return new Promise((resolve, reject) => {
            this.localDB = new PouchDB('tempDatabase');
            resolve(true)
        });

    }
}


// WEBPACK FOOTER //
// ./src/app/shared/pouchDb.service.ts